import script from "./tissue.vue?vue&type=script&setup=true&lang=js"
export * from "./tissue.vue?vue&type=script&setup=true&lang=js"

import "./tissue.vue?vue&type=style&index=0&id=98ae599a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98ae599a"]])

export default __exports__